<template>
  <div v-if="showBell">
    <button
      id="followButton"
      @click="toggleFollow"
      class="flex items-center gap-1 border border-solid border-theme-secondary rounded-[5px] px-2 py-1 hover:bg-black hover:text-white transition-colors duration-200 ease-in-out"
      :class="
        spot.userData.follows ? ' text-white bg-theme-secondary' : 'text-black'
      "
    >
      <Icon
        :name="
          spot.userData.follows
            ? 'material-symbols:notifications-active'
            : 'material-symbols:notifications-off'
        "
        size="1.5em"
      />
      {{
        spot.userData.follows
          ? $t('spotdetail.isFollowing')
          : $t('spotdetail.follow')
      }}
    </button>
  </div>
</template>
<script setup lang="ts">
const { $api } = useNuxtApp();

const props = defineProps<{ spot: SpotDetail }>();

const { loggedIn } = useUserSession();

watch(
  () => props.spot.userData.follows,
  (value) => {
    props.spot.userData.follows = value;
  }
);

const showBell = computed(() => {
  return loggedIn.value;
});

function toggleFollow() {
  let endpoint = 'follow';

  if (props.spot.userData.follows) {
    endpoint = 'unfollow';
  }

  $api('spots/' + props.spot.id.toString() + '/' + endpoint, { method: 'POST' })
    .then(function (response) {
      props.spot.userData.follows = !props.spot.userData.follows;
    })
    .catch(function (error) {
      console.log(error);
    });
}
</script>
<style scoped lang="postcss">
#followButton:hover svg {
  @apply fill-white stroke-white transition-colors duration-200 ease-in-out;
}
</style>
